import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LOADING_MESSAGES: Record<string, string> = {
  "/dashboard": "Preparando seus projetos...",
  "/editor": "Abrindo o editor...",
  "/settings": "Abrindo configurações...",
};

function get_loading_message(pathname: string): string {
  for (const [key, msg] of Object.entries(LOADING_MESSAGES)) {
    if (pathname.startsWith(key)) return msg;
  }
  return "Carregando...";
}

/** Loading de tela inteira (rotas publicas / splash inicial) */
export function LoadingScreen() {
  const [progress, set_progress] = useState(0);
  const location = useLocation();
  const message = get_loading_message(location.pathname);

  useEffect(() => {
    const interval = setInterval(() => {
      set_progress((p) => {
        if (p >= 90) return p + 0.2;
        if (p >= 70) return p + 0.5;
        if (p >= 40) return p + 2;
        return p + 4;
      });
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-background transition-colors">
      <div className="w-48 h-1 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-100 ease-out"
          style={{ width: `${Math.min(progress, 95)}%` }}
        />
      </div>
      <p className="text-sm text-muted-foreground tracking-wide">
        {message}
      </p>
    </div>
  );
}

/** Loading inline que ocupa apenas a area de conteudo (nav permanece visivel) */
export function ContentLoading() {
  const [progress, set_progress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      set_progress((p) => {
        if (p >= 90) return p + 0.2;
        if (p >= 70) return p + 0.5;
        if (p >= 40) return p + 2;
        return p + 4;
      });
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-1 w-full min-h-[60vh] flex-col items-center justify-center gap-4">
      <div className="w-48 h-1 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-100 ease-out"
          style={{ width: `${Math.min(progress, 95)}%` }}
        />
      </div>
      <p className="text-sm text-muted-foreground tracking-wide">
        Carregando...
      </p>
    </div>
  );
}
